import React from "react";
const UploadStatusModal = ({ result, show }) =>
  show && result ? (
    <div className={`modal ${result.status === "Processing" ? "modal-success" : "modal-failure"}`}>
      <strong>{result.status}</strong>
    </div>
  ) : null;
export default UploadStatusModal;